import { CustomerInvoicesFilter } from '../../customers/shared/models';
import { Subject } from 'rxjs/Subject';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { MenuItem } from 'ng2-material-components/ng2-material-components';
import { IAppEvent } from '../models';
import { EmployeeInvoicesFilter } from '../../employees/shared/models';
import { Product } from '../../inventory/shared/models';
import { LocationInvoiceDetailFilter} from '../../location/shared/models';
import 'rxjs/Rx';

export interface State {
  company: string;
  headerActions: MenuItem[];
  employeeInvoicesFilter: EmployeeInvoicesFilter;
  products: Product[];
  locationInvoiceDetailFilter: LocationInvoiceDetailFilter;
  customerInvoicesFilter: CustomerInvoicesFilter;
}

const defaultState = {
  company: null,
  headerActions: [],
  employeeInvoicesFilter: new EmployeeInvoicesFilter(null, null),
  products: [],
  locationInvoiceDetailFilter: new LocationInvoiceDetailFilter(null, null),
  customerInvoicesFilter: new CustomerInvoicesFilter(null, null, null),
  users: []
};

const _store = new BehaviorSubject<State>(defaultState);
const _actionsSubject = new Subject<IAppEvent>();

@Injectable()
export class Store {
  changes$: Observable<State>;
  appEvents$: Observable<IAppEvent>;

  private _store = _store;
  private _actionsSubject = _actionsSubject;

  constructor() {
    this.changes$ = this._store.asObservable().distinctUntilChanged();
    this.appEvents$ = this._actionsSubject.asObservable().distinctUntilChanged();
  }

  pushAppEvent(actionData: IAppEvent) {
      this._actionsSubject.next({
          type: actionData.type,
          data: actionData.data
      });
  }

  setState(state: State) {
    this._store.next(state);
  }

  getState(): State {
    return this._store.value;
  }

  purge() {
    this._store.next(defaultState);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/services/store.ts